module.exports = __webpack_public_path__ + "static/media/section.10a5341d.png";